// Need for dropdown to understand null options.
// It requires empty string on number.
export function prepareFormValue<T>(obj: T): T {
    return Object.keys(obj).reduce((result, key) => {
        return {
            ...result,
            [key]: result[key] === null ? '' : result[key]
        };
    }, obj);
}
